import React, { Component } from 'react'
import WalletData from './walletData'
import Recaptcha from 'react-recaptcha'
import CommonFetch from '../../../requests/commonFetch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class Confirmation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            initialPage: true,
            tfaPage: false,
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        let { subscribeData, subscribeInfo } = this.props
        let { fail_url } = subscribeData
        let {
            action_id,
            complete_success,
            complete_investor_address,
        } = subscribeInfo

        return (
            <div className="subscribe__box_right">
                <WalletData subscribeData={this.props.subscribeData} />
                {this.subscribeConfirmationForm()}
                <a
                    href={`${fail_url}action_id=${action_id}&complete_success=${
                        complete_success ? 1 : 0
                    }&investor_address=${complete_investor_address}`}
                >
                    <button className="subscribe__button subscribe__button_close">
                        {this.translation['Refuse']}
                    </button>
                </a>
            </div>
        )
    }

    subscribeConfirmationForm = () => {
        let { loading } = this.state
        let { subscribeState, subscribeTFA } = this.props
        return (
            <form
                className="subscribe-form subscribe-form_margin-top-m"
                onSubmit={this.subscribeRequest}
            >
                {subscribeState === 'wait_2fa_code' ? (
                    <React.Fragment>
                        {subscribeTFA ? (
                            <p className="subscribe__desc subscribe__margin-bottom_m">{`${
                                this.translation[
                                    'Two-factor authentication type'
                                ]
                            }: ${this.getCorrectTFAType(
                                this.props.subscribeTFA
                            )}`}</p>
                        ) : null}
                        <div className="subscribe-form__group subscribe__margin-bottom_m">
                            <input
                                type="text"
                                name="2fa_code"
                                className="subscribe-form__input"
                                placeholder="TFA Code"
                                id="tfaCode"
                                autoComplete="off"
                                required
                            />
                            <label
                                htmlFor="tfaCode"
                                className="subscribe-form__label"
                            >
                                TFA Code
                            </label>
                        </div>
                    </React.Fragment>
                ) : (
                    this.recaptchaWrap()
                )}
                {!loading ? (
                    <input
                        className="subscribe__button"
                        type="submit"
                        value={
                            subscribeState === 'wait_2fa_code'
                                ? this.translation['Check']
                                : this.translation['Continue']
                        }
                    />
                ) : (
                    <div className="payment__spinner">
                        <FontAwesomeIcon icon={'spinner'} />
                    </div>
                )}
            </form>
        )
    }

    getCorrectTFAType = type => {
        switch (type) {
            case 'email':
                return 'Email'
                break
            case 'sms':
                return 'SMS'
                break
            case 'ga':
                return 'Google Authenticator'
                break
            case 'none':
                return 'None'
                break
            default:
                return 'Unknown'
                break
        }
    }

    subscribeRequest = event => {
        event.preventDefault()
        let form = new FormData(event.target)
        form.append('id', this.props.subscribeData.id)
        this.changeLoadingStatus()
        CommonFetch({
            path: `ui/subscriptions/post_${this.props.pathname}`,
            method: 'POST',
            data: form,
        }).then(data => {
            console.log(data)
            this.changeLoadingStatus()
            this.props.getSubscribeInfo()
        })
    }

    changeLoadingStatus = () => {
        this.setState({
            loading: !this.state.loading,
        })
    }

    recaptchaWrap = () => {
        let { captchaKey } = this.props

        if (!captchaKey) return null
        return (
            <Recaptcha
                sitekey={`${captchaKey}`}
                render="explicit"
                theme="dark"
                size="normal"
                badge="inline"
                hl={localStorage.language}
            />
        )
    }
}
